import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { authAPI } from '../api/api';

interface VerifiedRouteProps {
  children: React.ReactNode;
}

const VerifiedRoute: React.FC<VerifiedRouteProps> = ({ children }) => {
  const [status, setStatus] = useState<'loading' | 'verified' | 'unverified' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    authAPI
      .getMe()
      .then((user) => {
        if (!cancelled) {
          setStatus(user.email_verified ? 'verified' : 'unverified');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStatus('error');
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'loading') {
    return (
      <div className="container" style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (status === 'unverified') {
    return <Navigate to="/verify-email" replace />;
  }

  if (status === 'error') {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default VerifiedRoute;
